<template>
  <table class="table table-borderless">
    <tr>
      <td width="20%">Руководитель</td>
      <td align="center">
        <div class="row border-bottom" style="min-height: 2rem">
          <div class="col-12">{{org.chief}}</div>
        </div>

        <small class="text-muted">Подпись, расшифровка подписи</small>
      </td>
    </tr>
    <tr>
      <td width="20%">Главный бухгалтер</td>
      <td align="center">
        <div class="row border-bottom">
          <div class="col-12" style="min-height: 2rem">{{org.accountant}}</div>
        </div>
        <small class="text-muted">Подпись, расшифровка подписи</small>
      </td>
    </tr>
  </table>
</template>


<script>
export default {
  name: 'Signature',
  props: ['org']
}
</script>